import React from "react";
//
import { FlexDiv, Box } from "@/components/Atoms";
import EnrollNowButton from "@/components/Molecules/EnrollNowButton";
//
import { useAppSelector, useWindowDimensions } from "@/hooks";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

//
import {
  Wrapper,
  Title,
  ButtonDiv,
  OverrideHeaderStyle,
  Container,
  LeftSection,
  IconRing,
  SubTitle,
  // Description,
  // FeatureTitle,
  FeatureItem,
  Stars,
  FeatureSubtitle,
  FeaturesDiv,
} from "./style";

function HeroSection({ h1Text, data = {}, scrollToHowItWorks, scrollToForm }) {
  const { width } = useWindowDimensions();

  const {
    title,
    secondaryCTA,
    image,
    subtitle,
    // description,
    goalList,
    heroSecondCTAText,
    features,
    heroStyles,
  } = data;

  const { headerHeight } = useAppSelector((state) => state.dashboard);

  return (
    <Wrapper id="hero-section" topDistance={headerHeight}>
      <Container>
        <LeftSection image={image} heroStyles={heroStyles}>
          <Title
            variant={h1Text ? "heading2" : "heading1"}
            dangerouslySetInnerHTML={{ __html: title }}
            isExtraBold
            fontSize={["30px", "38px", "44px"]}
            lineHeight={["40px", "44px", "48px"]}
          />
          {subtitle && (
            <SubTitle
              variant="heading4"
              color={theme.colorsV2.shyft.purple_text}
              dangerouslySetInnerHTML={{ __html: subtitle }}
              fontSize={["20px", "20px", "28px"]}
              lineHeight={["24px", "24px", "40px"]}
            />
          )}
          {features?.length > 0 && (
            <FeaturesDiv mb="30px">
              {features?.map((item, index) => {
                if (width <= 1023 && index <= 1) {
                  return (
                    <FeatureItem key={index}>
                      <Stars icon="icon-sparkling-stars" />
                      <FeatureSubtitle variant="label3">
                        {item?.title}
                      </FeatureSubtitle>
                    </FeatureItem>
                  );
                } else if (width > 767) {
                  return (
                    <FeatureItem key={index}>
                      <Stars icon="icon-sparkling-stars" />
                      <FeatureSubtitle variant="label3">
                        {item?.title}
                      </FeatureSubtitle>
                    </FeatureItem>
                  );
                }
              })}
            </FeaturesDiv>
          )}
          {/* <Description
            variant="heading6"
            color={theme.colorsV2.shyft.purple_text}
            dangerouslySetInnerHTML={{ __html: description }}
          /> */}
          {!subtitle && (
            <FlexDiv
              flexWrap={"wrap"}
              width="100%"
              justifyContent={["center", "center", "flex-start"]}
              alignContent="flex-start"
              mb="40px"
              style={{ gap: "32px" }}
            >
              {goalList?.map((item, index) => {
                return (
                  <Box
                    maxWidth={["75px", "95px"]}
                    key={index}
                    style={{ cursor: "pointer" }}
                    onClick={scrollToHowItWorks}
                  >
                    <FlexDiv
                      flexDirection={"column"}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <IconRing mb={"8px"}>
                        <img
                          src={item?.image_mob}
                          height={width <= 1024 ? "60px" : "72px"}
                          width={width <= 1024 ? "60px" : "72px"}
                          alt="health-goal"
                        />
                      </IconRing>
                      <Typography
                        variant="label2"
                        color={theme.colors.gray_100}
                        textAlign="center"
                        fontSize={["12px", "16px"]}
                        lineHeight={["17px", "20px"]}
                        fontWeight={["600"]}
                      >
                        {item.title}
                      </Typography>
                    </FlexDiv>
                  </Box>
                );
              })}
            </FlexDiv>
          )}
          <ButtonDiv>
            <EnrollNowButton
              content={secondaryCTA}
              onClick={scrollToHowItWorks}
            />

            {heroSecondCTAText && (
              <EnrollNowButton
                content={heroSecondCTAText}
                onClick={scrollToForm}
              />
            )}
          </ButtonDiv>
        </LeftSection>
      </Container>
      <OverrideHeaderStyle />
    </Wrapper>
  );
}

export default HeroSection;
